// extracted by mini-css-extract-plugin
export default {"imageWrapper":"BJ-z","twoColumnImage":"CJ-z"};